import { css } from '@/styled-system/css';

export const spokeContainer = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const spokeBody = css({
  py: '2x',
  flex: 1,
  overflowY: 'auto',
});

export const loadingOverlay = css({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  zIndex: 'zIndexStep',
});

export const loadingSpinner = css({
  width: '32px',
  height: '32px',
  borderWidth: '3px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderTopColor: 'hpxTeal500',
  borderRadius: '50%',
  animationName: 'spin',
  animationDuration: '0.8s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
});

export const spokeFormWrapper = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});

export const scrollableContent = css({
  flex: 1,
  overflowY: 'auto',
  minHeight: 0,
});

export const spokeFormContent = css({
  paddingTop: '12px',
  paddingBottom: '12px',
  paddingLeft: '2x',
  paddingRight: '2x',
  md: {
    paddingTop: '2x',
    paddingBottom: '2x',
  },
});
